import { ReactElement } from 'react';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import { CartItem } from '../cart-item/CartItem';
import { RemovedCartItem } from '../cart-item/RemovedCartItem';
import { SignupProgressStepper } from './SignupProgressStepper';
import styles from './SignupDrawer.module.scss';
import { SignupStep } from '../../constants/signup';

export function SignupOrderSummary(): ReactElement {
  const {
    cart,
    updateCartQuantity,
    currentSignupStep,
  } = useMenuWithCart();
  const extendedAreaSurcharge = currentSignupStep === SignupStep.PAYMENT ? cart?.priceSummary?.extendedAreaSurcharge : 'TBD';
  const couponAmount = cart?.priceSummary?.couponAmount;
  const couponCode = cart?.priceSummary?.couponName;
  const isCouponApplied = cart?.priceSummary?.isCouponApplied;
  const showCouponText = couponAmount != null && couponCode != null && isCouponApplied;

  return (
    <div
      className={
        showCouponText
          ? styles.signup_order_summary_container_coupon
          : styles.signup_order_summary_container
      }
    >
      <div className={styles.price_summary}>
        <div className={styles.price_summary_line_item}>
          <div>Sub Total:</div>
          <div>{cart?.priceSummary.subtotal}</div>
        </div>
        <div className={styles.price_summary_line_item}>
          <div>Shipping:</div>
          <div>{cart?.priceSummary.shipping}</div>
        </div>
        {!!extendedAreaSurcharge && (
          <div className={styles.price_summary_line_item}>
            <div>Extended Area Surcharge:</div>
            <div>{extendedAreaSurcharge}</div>
          </div>
        )}
        <div className={styles.price_summary_line_item}>
          <div>Discounts:</div>
          <div>{`- ${cart?.priceSummary.totalDiscountAmount}`}</div>
        </div>
      </div>

      <div
        className={styles.cart_scroll_area}
        data-heap-id={`signup_order_summary_cart_${cart?.id}`}
      >
        <hr style={{ margin: 0 }} />
        {cart?.cartItems?.filter((cartItem) => !cartItem.isPromoCartItem).map((cartItem) => (
          (cartItem?.quantity && cartItem?.quantity > 0) ? (
            <CartItem
              title={cartItem.title}
              key={cartItem.title}
              description={cartItem.description}
              imageUrl={cartItem.imageURL}
              totalPrice={cartItem.totalPrice}
              skuPrice={cartItem.skuPrice}
              pricePerServing={cartItem.pricePerServing}
              servingSize={cartItem.servingSize}
              quantity={cartItem.quantity || 0}
              isCartSkipped={cart.isSkipped}
              isSaleTagEnabled={cartItem.saleTagEnabled}
              salePrice={cartItem.salePrice}
              isActive
              onUpdateCartQuantity={
                (quantity: number) => updateCartQuantity(cartItem, quantity)
              }
              heapId={`cart_item_${cartItem.skuId}`}
              skuId={cartItem.skuId}
              path={cartItem.productPath}
              onClickImage={() => null}
              isLtoBox={cartItem.isLtoBox}
              ltoServings={cartItem.ltoServings}
              isPromoItem={!!cartItem.isPromoCartItem}
            />
          ) : (
            <RemovedCartItem
              title={cartItem.title}
              key={cartItem.title}
              onClick={() => {
                updateCartQuantity(cartItem, 1);
              }}
            />
          )
        ))}
      </div>

      <SignupProgressStepper />
    </div>
  );
}
